import * as Comp from "../../common/CommonComponents";
import * as common from "../../common/common";
import http from "../../common/http-common";
import CssClass from "../../Styles/common.module.css";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { GetPagePermissionFn } from "../../common/authority";
// import PolicyConfigTable from "../../components/MasterSetup/Policy/PolicyConfigTable";

const PAGE_NAME = "Policy.js_";
const MODULE_ID = "WEB_MAS_001";

const Policy = () => {
  document.title = common.c_TITLE + " - Policy Configuration";

  const navigate = useNavigate();

  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const [allData, setAllData] = useState([]);
  const [inputError, setInputError] = useState({});
  const [reload, setReload] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
  });

  useEffect(() => {
    let promise = GetPagePermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Home");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
        toast.error(error);
        navigate("/Home");
      }
    );
  }, [userId, navigate]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get All Configuration";

        setLoading(true);
        setLoadingText("Getting Configuration List, please wait...");

        setAllData([]);

        const listItems = [];

        http
          .get("api/policy/GetAllPolicy?_userId=" + userId, {
            timeout: 10000000,
          })
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data) => {
                listItems.push({
                  // POLICY_GROUP_ID: data.POLICY_GROUP_ID,
                  // POLICY_ID: data.POLICY_ID,
                  // POLICY_VALUE: data.POLICY_VALUE,
                  // POLICY_DESC: data.POLICY_DESC,
                  // ACTIVE_FLAG: data.ACTIVE_FLAG,
                  // STATUS: data.ACTIVE_FLAG === "Y" ? "Active" : "Inactive",
                  ATTACHMENT_PATH: data.ATTACHMENT_PATH,
                  EMAIL_ADDRESS: data.EMAIL_ADDRESS,
                  EMAIL_PASSWORD: data.EMAIL_PASSWORD,
                  EMAIL_PORT: data.EMAIL_PORT,
                  EMAIL_SERVER: data.EMAIL_SERVER,
                  LOGIN_FAIL: data.LOGIN_FAIL,
                  PASSWORD_A_REGEX: data.PASSWORD_A_REGEX,
                  PASSWORD_AGE: data.PASSWORD_AGE,
                });
              });
              setAllData(listItems[0]);
            }
          })
          .catch((err) => {
            toast.error(
              "Error on getting policy configuration list. Please try again."
            );
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            setLoading(false);
            setLoadingText("Loading...");
          });
      } catch (err) {
        toast.error(
          "Error on getting policy configuration list. Please try again."
        );
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }  
  }, [reload, actionAuthority, userId]);

  //#region Save
  const onEditSave = () => {
    let functionName = "";

    try {
      functionName = onEditSave.name;

      if (Object.values(inputError).filter((v) => v !== "").length === 0) {
        SaveEditPolicy(allData);
      }
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
      return false;
    }
  };

  const SaveEditPolicy = (_data) => {
    let functionName = "";

    try {
      functionName = SaveEditPolicy.name;

      onLoadingHandler(true, "Configuring Policy , please wait...");

      const data = {
        ATTACHMENT_PATH: _data.ATTACHMENT_PATH,
        EMAIL_ADDRESS: _data.EMAIL_ADDRESS,
        EMAIL_PASSWORD: _data.EMAIL_PASSWORD,
        EMAIL_PORT: _data.EMAIL_PORT,
        EMAIL_SERVER: _data.EMAIL_SERVER,
        LOGIN_FAIL: _data.LOGIN_FAIL,
        PASSWORD_A_REGEX: _data.PASSWORD_A_REGEX,
        PASSWORD_AGE: _data.PASSWORD_AGE,
        UPDATE_ID: userId,
      };
      http
        .put("api/policy/UpdatePolicy", data, {
          timeout: common.DEFAULT_TIMEOUT,
        })
        .then(() => {
          toast.success("Policy Configuration is successfully modified.");
          onReloadHandler();
        })
        .catch((err) => {
          toast.error(
            "Failed to modify policy configuration. Please try again."
          );
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          onLoadingHandler(false, "Loading...");
        });
    } catch (err) {
      onLoadingHandler(false, "Loading...");
      toast.error("Failed to modify policy configuration. Please try again.");
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  const onReloadHandler = () => {
    setReload(!reload);
  };

  const inputRequiredHandler = (event) => {
    let functionName = "";

    try {
      functionName = inputRequiredHandler.name;
      const name = event.target.name;
      functionName = inputRequiredHandler.name + "_" + name;
      const id = event.target.id;
      const val = event.target.value;
      if (val.length === 0) {
        setInputError((prevState) => ({
          ...prevState,
          [id]: name + " could not be empty",
        }));
      } else {
        setInputError((prevState) => ({
          ...prevState,
          [id]: "",
        }));
      }
      setAllData((prevState) => ({
        ...prevState,
        [id]: val,
      }));
    } catch (err) {
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  };

  return (
    <>
      <Comp.Header>Policy Configuration</Comp.Header>
      <div className={CssClass.btnWrapper}>
        {actionAuthority.WRITE === 'Y' && (
          <Comp.Button id="btnSave" type="general" onClick={onEditSave}>
            SAVE
          </Comp.Button>
        )}
      </div>
      <div className={`${CssClass.configCard} ${CssClass.configTableCard}`}>
        <h3 className={CssClass.tableTitle}>System Settings</h3>
        <div className={CssClass.flexContainer}>
          <table className="table">
            <tbody>
              <tr>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "15%",
                    borderStyle: "none",
                  }}
                >
                  Attachment Path
                </td>
                <td style={{ borderStyle: "none" }}> :</td>
                <td style={{ borderStyle: "none" }}>
                  <Comp.Input
                    id="ATTACHMENT_PATH"
                    type="text"
                    name="Attachment Path"
                    errorMessage={inputError.ATTACHMENT_PATH}
                    value={allData !== undefined ? allData.ATTACHMENT_PATH : ""}
                    disabled={actionAuthority.WRITE !== "Y"}
                    onChange={inputRequiredHandler}
                    onBlur={inputRequiredHandler}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className={`${CssClass.configCard} ${CssClass.configTableCard}`}>
        <h3 className={CssClass.tableTitle}>Email Notification Settings</h3>
        <div className={CssClass.flexContainer}>
          <table className="table">
            <tbody>
              <tr>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "15%",
                    borderStyle: "none",
                  }}
                >
                  Email Address
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "5%",
                    borderStyle: "none",
                  }}
                >
                  {" "}
                  :
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "30%",
                    borderStyle: "none",
                  }}
                >
                  <Comp.Input
                    id="EMAIL_ADDRESS"
                    type="text"
                    name="Email Address"
                    errorMessage={inputError.EMAIL_ADDRESS}
                    value={allData !== undefined ? allData.EMAIL_ADDRESS : ""}
                    disabled={actionAuthority.WRITE !== "Y"}
                    onChange={inputRequiredHandler}
                    onBlur={inputRequiredHandler}
                  />
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "15%",
                    borderStyle: "none",
                  }}
                >
                  Email Password
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "5%",
                    borderStyle: "none",
                  }}
                >
                  {" "}
                  :
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "30%",
                    borderStyle: "none",
                  }}
                >
                  <Comp.Input
                    id="EMAIL_PASSWORD"
                    type="text"
                    name="Password"
                    errorMessage={inputError.EMAIL_PASSWORD}
                    value={allData !== undefined ? allData.EMAIL_PASSWORD : ""}
                    disabled={actionAuthority.WRITE !== "Y"}
                    onChange={inputRequiredHandler}
                    onBlur={inputRequiredHandler}
                  />
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "15%",
                    borderStyle: "none",
                  }}
                >
                  Email Port
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "5%",
                    borderStyle: "none",
                  }}
                >
                  {" "}
                  :
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "30%",
                    borderStyle: "none",
                  }}
                >
                  <Comp.Input
                    id="EMAIL_PORT"
                    type="number"
                    name="Email Port"
                    errorMessage={inputError.EMAIL_PORT}
                    value={allData !== undefined ? allData.EMAIL_PORT : ""}
                    disabled={actionAuthority.WRITE !== "Y"}
                    onChange={inputRequiredHandler}
                    onBlur={inputRequiredHandler}
                  />
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "15%",
                    borderStyle: "none",
                  }}
                >
                  Email Server
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "5%",
                    borderStyle: "none",
                  }}
                >
                  {" "}
                  :
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "30%",
                    borderStyle: "none",
                  }}
                >
                  <Comp.Input
                    id="EMAIL_SERVER"
                    type="text"
                    name="Email Server"
                    errorMessage={inputError.EMAIL_SERVER}
                    value={allData !== undefined ? allData.EMAIL_SERVER : ""}
                    disabled={actionAuthority.WRITE !== "Y"}
                    onChange={inputRequiredHandler}
                    onBlur={inputRequiredHandler}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className={`${CssClass.configCard} ${CssClass.configTableCard}`}>
        <h3 className={CssClass.tableTitle}>Login Policy</h3>
        <div className={CssClass.flexContainer}>
          <table className="table">
            <tbody>
              <tr>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "15%",
                    borderStyle: "none",
                  }}
                >
                  Login Fail Attempt
                </td>
                <td style={{ borderStyle: "none" }}> :</td>
                <td style={{ borderStyle: "none" }}>
                  <Comp.Input
                    id="LOGIN_FAIL"
                    type="number"
                    name="Login Fail Attempt"
                    errorMessage={inputError.LOGIN_FAIL}
                    value={allData !== undefined ? allData.LOGIN_FAIL : ""}
                    disabled={actionAuthority.WRITE !== "Y"}
                    onChange={inputRequiredHandler}
                    onBlur={inputRequiredHandler}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className={`${CssClass.configCard} ${CssClass.configTableCard}`}>
        <h3 className={CssClass.tableTitle}>Password Policy</h3>
        <div className={CssClass.flexContainer}>
          <table className="table">
            <tbody>
              <tr>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "15%",
                    borderStyle: "none",
                  }}
                >
                  Password Regex
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "5%",
                    borderStyle: "none",
                  }}
                >
                  {" "}
                  :
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "30%",
                    borderStyle: "none",
                  }}
                >
                  <Comp.Input
                    id="PASSWORD_A_REGEX"
                    type="text"
                    name="Password Regex"
                    errorMessage={inputError.PASSWORD_A_REGEX}
                    value={
                      allData !== undefined ? allData.PASSWORD_A_REGEX : ""
                    }
                    disabled={actionAuthority.WRITE !== "Y"}
                    onChange={inputRequiredHandler}
                    onBlur={inputRequiredHandler}
                  />
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "15%",
                    borderStyle: "none",
                  }}
                >
                  Password Age (Days)
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "5%",
                    borderStyle: "none",
                  }}
                >
                  {" "}
                  :
                </td>
                <td
                  style={{
                    verticalAlign: "middle",
                    width: "30%",
                    borderStyle: "none",
                  }}
                >
                  <Comp.Input
                    id="PASSWORD_AGE"
                    type="number"
                    name="Password Age"
                    errorMessage={inputError.PASSWORD_AGE}
                    value={allData !== undefined ? allData.PASSWORD_AGE : ""}
                    disabled={actionAuthority.WRITE !== "Y"}
                    onChange={inputRequiredHandler}
                    onBlur={inputRequiredHandler}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default Policy;
